module.exports = __webpack_public_path__ + "HelveticaBoldOblique.80ea75bb333a0f7ffe7b.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-dinamica-cliente/src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.woff
// module chunks = styles